import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { SearchRequest } from '../../Models/SearchRequest';
import SearchTable from './SearchTable';
import SearchApi from '../../Api/SearchApi';
import { SearchResult } from '../../Models/SearchResult';
import Loader from '../Common/Loader';
import { toast } from 'react-toastify';

export default function Search({
  show,
  setShow,
  initialSearchData,
  initialSearchText = '',
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  initialSearchData: SearchResult[] | null;
  initialSearchText?: string;
}) {
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: initialSearchText || '',
    category: '',
    selectedTagIds: [],
  });
  const [searchData, setSearchData] = useState<SearchResult[]>(
    initialSearchData ?? []
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Keep modal in sync when top-nav search opens it with results.
  useEffect(() => {
    if (!show) return;
    setSearchData(initialSearchData ?? []);
    setFormData((prev) => ({
      ...prev,
      searchText: initialSearchText || prev.searchText,
    }));
  }, [show, initialSearchData, initialSearchText]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const res = await SearchApi.search(formData);
      setSearchData(Array.isArray(res.data) ? res.data : []);
      if (!res.data?.length) {
        toast.info('No members matched that search.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Member search failed. Please try again.');
      setSearchData([]);
    } finally {
      setIsLoading(false);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size='3xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='flex justify-center text-3xl font-bold'>
          Member Search
        </div>
        <div className='w-full pt-4'>
          <div className='w-full mx-auto pb-3'>
            <form onSubmit={onSubmit} className='flex justify-center'>
              <TextInput
                id='memberSearchModalText'
                name='searchText'
                type='text'
                placeholder='Search...'
                onChange={handleChange}
                value={formData.searchText}
                className='w-2/3 pr-1'
              />
              <Button type='submit' className='buttonMain'>
                Search
              </Button>
            </form>
          </div>
          <div className='w-full p-2'>
            {isLoading && <Loader />}
            {!isLoading && searchData.length === 0 ? (
              <p className='text-center text-gray-500 py-6'>
                No members found.
              </p>
            ) : (
              <SearchTable data={searchData} setShow={setShow} />
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
